/** Fixed-position container that renders active toasts stacked from bottom-right. */

import { Toast } from './Toast'
import { useToast } from '../../hooks/useToast'

export function ToastContainer() {
  const { toasts, dismiss } = useToast()

  if (toasts.length === 0) return null

  return (
    <div
      data-testid="toast-container"
      className="fixed right-4 bottom-4 z-50 flex flex-col-reverse gap-2"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <Toast
          key={t.id}
          id={t.id}
          variant={t.variant}
          message={t.message}
          duration={t.duration}
          onDismiss={dismiss}
        />
      ))}
    </div>
  )
}
